import { type RefObject } from 'react';
import React, {
  createContext,
  createRef,
  useContext,
  useMemo,
  useRef,
} from 'react';

const EditableContext = createContext<{
  contentEditableRef: RefObject<undefined>;
}>({
  contentEditableRef: createRef(),
});

export const useEditableContext = () => {
  const context = useContext(EditableContext);

  if (!context) {
    throw new Error(
      'useEditableContext must be used within a EditableProvider',
    );
  }

  return context;
};

interface EditableProviderProps {
  children: React.ReactNode;
}

export const EditableProvider = ({ children }: EditableProviderProps) => {
  const contentEditableRef = useRef();

  const providerState = useMemo(
    () => ({
      contentEditableRef,
    }),
    [contentEditableRef],
  );

  return (
    <EditableContext.Provider value={providerState}>
      {children}
    </EditableContext.Provider>
  );
};

export default EditableContext;
